const navbar = {
  HOME: "navbar:home",
  ACCOUNT: "navbar:account",
  PROJECTS: "navbar:projects",
  CONNECTIONS: "navbar:connections",
  SERVICES: "navbar:services",
  SERVICES_BALANCES: "navbar:services:balances",
  TRANSACTIONS: "navbar:transactions",
  PAYMENTS: "navbar:payments",
  PAYOUTS: "navbar:payouts",
  TRANSFER: "navbar:transfer",
  EXCHANGE: "navbar:exchange",
  CURRENCIES: "navbar:currencies",
  FEE: "navbar:fee",
  USERS: "navbar:users",
  DEFAULT_FEE: "navbar:default:fee",
  RATES: "navbar:rates",
  CLIENT_FEES: "navbar:client:fees",
  BASE_RATES: "navbar:base:rates",
  BATCHES: "navbar:batches",
  LOGS: "navbar:logs",
  BLOCKCHAIN_URL: "navbar:blockchain:url",
  CASH_FLOW: "navbar:cash:flow",
  SUPPORT_USER: "navbar:support:user",
  SYSTEM_COMMAND: "navbar:system:command",
  MASTER_BALANCE: "navbar:master:balance",
  MASTER_REFILLING: "navbar:master:refilling",
  BIN_DATA: "navbar:admin:bin-data",
  SWAP: "navbar:master:swap",
  WALLETS: "navbar:wallets",
  WALLET_MAIN_WHITELIST: "navbar:wallet:main:whitelist",
  WALLET_WHITELIST: "navbar:wallet:whitelist",
  TELEGRAM_BOT: "navbar:telegram:bot"
};

const account = {
  ADMIN: "account:admin",
  USER: "account:user",
  SUPPORT: "account:support"
};

const service = {
  SUPER_ADMIN: "service:super:admin",
  ADMIN: "service:admin",
  USER: "service:user",
  CLIENT_LIST: "service:client:list"
};

const serviceBalance = {
  SUPER_ADMIN: "service:balances:super:admin",
  ADMIN: "service:balances:admin",
};

const currencies = {
  ADMIN: "currencies:admin"
};

const connectedServices = {
  USER: "connected:services:user"
};

const transactions = {
  SUPER_ADMIN: "transactions:super:admin"
};

const payment = {
  USER: "payment:user",
  ADMIN: "payment:admin",
  SUPPORT: "payment:support",
  SUPER_ADMIN: "payment:super:admin"
};

const payout = {
  USER: "payout:user",
  ADMIN: "payout:admin",
  SUPPORT: "payout:support",
  SUPER_ADMIN: "payout:super:admin"
};

const transfer = {
  USER: "transfer:user",
  ADMIN: "transfer:admin"
};

const exchanger = {
  USER: "exchanger:user",
  MASTER: "exchanger:master",
  ADMIN: "exchanger:admin",
};

const project = {
  USER: "project:user"
};

const fee = {
  ADMIN: "fee:admin",
  USER: "fee:user",
  PAIR_UNIT_MANAGER: "fee:pair:unit:manager"
};

const defaultFee = {
  ADMIN: "default:fee:admin"
};

const users = {
  SUPER_ADMIN: "users:super:admin",
  ADMIN: "users:admin"
};

const rates = {
  ADMIN: "rates:admin",
  USER: "rates:user",
  PAIR_UNIT_MANAGER: "rates:pair:unit:manager"
};

const baseRates = {
  ADMIN: "base:rates:admin"
};

const batches = {
  USER: "batches:user",
  ADMIN: "batches:admin"
};

const logs = {
  ADMIN: "logs:admin"
};

const blockchainUrl = {
  ADMIN: "blockchain:url:admin"
};

const cashFlow = {
  ADMIN: "cash:flow:admin",
  USER: "cash:flow:user"
};

const supportUser = {
  SUPER_ADMIN: "support:user:super:admin"
};

const systemCommand = {
  SUPER_ADMIN: "system:command:super:admin"
};

const nickname = {
  CHANGE: "change"
};
const userAdminFields = {
  CHANGE: "change"
};


const masterBalance = {
  MASTER: "master:balance:master"
};

const masterRefilling = {
  MASTER: "master:refilling:master"
};

const binData = {
  ADMIN: "admin:bin-data",
  CREATE: "admin:bin-data:action",
}

const swap = {
  MASTER: "master:swap:master"
};

const wallets = {
  ADMIN: "wallets:admin",
  USER: "wallets:user"
};

const walletDetails = {
  ADMIN: "wallet:details:admin",
  USER: "wallet:details:user"
};

const walletMainWhitelist = {
  ADMIN: "wallet:main:whitelist:admin"
};

const walletWhitelist = {
  ADMIN: "wallet:whitelist:admin",
  USER: "wallet:whitelist:user"
};

const telegramBot = {
  USER: "telegram:bot:user"
};

export {
  navbar,
  account,
  service,
  serviceBalance,
  currencies,
  connectedServices,
  transactions,
  payment,
  payout,
  transfer,
  exchanger,
  project,
  fee,
  users,
  defaultFee,
  rates,
  batches,
  logs,
  baseRates,
  blockchainUrl,
  cashFlow,
  supportUser,
  systemCommand,
  nickname,
  masterBalance,
  masterRefilling,
  userAdminFields,
  binData,
  swap,
  wallets,
  walletDetails,
  walletMainWhitelist,
  walletWhitelist,
  telegramBot,
};